import ActionButton from 'components/Widget/ActionButton';
import { IconType } from 'components/Icon';
import { Frame } from 'dragonmouse-shared/interfaces';
import { shallowEqual, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { selectFrames } from 'redux/db/reducers';
import { RootReducer } from 'redux/reducers';
import { navigate } from 'utils';
import { trackMiscAction } from 'analytics';
import * as routes from 'routes';

interface Props {
	label: string;
	frameId: string;
}

const OpenPrototypeAction = ({ label, frameId }: Props) => {
	const allFrames = useSelector((r: RootReducer) => selectFrames(r.db), shallowEqual);

	const onClick = () => {
		const frame: Frame | undefined = allFrames.find((f) => f.id === frameId);
		if (!frame) {
			toast.error('Frame not found');
			return;
		}
		trackMiscAction('load_view_prototype');
		navigate(routes.modifyCurrentPath({ frameId }));
	};

	return <ActionButton icon={IconType.PLAY} label={label} onClick={onClick} />;
};

export default OpenPrototypeAction;
